var axios = require('axios');

var axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DOMAIN,
});

module.exports = axiosInstance;
